import React, { Component, Suspense } from 'react';
import { Panel, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigate } from 'raviger';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import { royaltyPlanTemplateSelect } from '../../store/actions/royaltyPlanTemplate';
import { royaltyPlanFeeTemplateList } from '../../store/actions/royaltyPlanFeeTemplate';
import { alertAdd } from '../../store/actions/alert';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';

import Spinner from '../../components/Spinner/Spinner';

import * as constants from '../../constants';

import './RoyaltyPlanTemplate.css';

const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const RoyaltyPlanTemplateForm = React.lazy(() => import('../../components/Forms/RoyaltyPlanTemplateForm/RoyaltyPlanTemplateForm'));
const NoteTab = React.lazy(() => import('../../components/Tabs/NoteTab/NoteTab'));
const RoyaltyPlanTemplateOtherFeeTab = React.lazy(() => import('../../components/Tabs/RoyaltyPlanTemplateOtherFeeTab/RoyaltyPlanTemplateOtherFeeTab'));
const RoyaltyPlanTemplateAgentFeeTab = React.lazy(() => import('../../components/Tabs/RoyaltyPlanTemplateAgentFeeTab/RoyaltyPlanTemplateAgentFeeTab'));
const NewBreadCrumbTitle = 'New Royalty Plan';
const EditBreadCrumbTitle = 'Edit Royalty Plan';

class RoyaltyPlanTemplate extends Component {
    state = {
        selectedTab: null
    };

    componentDidMount() {
        this.props.addBreadcrumb({ key: 'royaltyPlanTemplates', parent: 'Settings', text: 'Royalty Plans', path: '/royaltyPlanTemplates' });
        let crumb = { key: 'edit_royaltyPlanTemplate', parent: EditBreadCrumbTitle, text: 'Royalty Plan Info' };

        if (window.location.pathname.includes('/royaltyPlanTemplates/new')) {
            crumb = { key: 'new_royaltyPlanTemplate', parent: NewBreadCrumbTitle, text: 'Royalty Plan Info' };

            this.props.onRoyaltyPlanTemplateSelect();
        } else {
            // NOTE: Temporary until component is written for hooks
            const royaltyPlanTemplateId = window.location.pathname.replace('/royaltyPlanTemplates/edit/', '');

            this.props.onRoyaltyPlanTemplateSelect({ royaltyPlanTemplateId: royaltyPlanTemplateId });
        }

        this.props.addBreadcrumb(crumb);
    };

    componentDidUpdate() {
        if (this.props.lastState === constants.STATE_FAIL && this.props.error && this.props.error.message) {
            this.props.onAlertAdd({ key: constants.ALERT_SERVER_ERROR, text: <strong>{this.props.error.message}</strong>, type: constants.ALERT_TYPE_DANGER });
        }
    };

    componentWillUnmount() {
        this.props.removeBreadcrumb();
    }

    submittedHandler = () => {
        navigate(`/royaltyPlanTemplates`);
    };

    cancelledHandler = () => {
        navigate(`/royaltyPlanTemplates`);
    };

    tabSelectedHandler = (tabKey) => {
        if (tabKey !== this.state.selectedTab) {
            this.props.removeBreadcrumb();
        }
        let feeType = null;

        if (tabKey !== 'notes') {
            switch (tabKey) {
                case 'otherFees': {
                    feeType = 'Recurring';
                    this.props.addBreadcrumb({ key: 'royalty-plan-others', parent: this.props.isNew ? NewBreadCrumbTitle : EditBreadCrumbTitle, text: 'Other Recurring Fees' });
                    break;
                }
                case 'agentFees': {
                    feeType = 'Agent';
                    this.props.addBreadcrumb({ key: 'royalty-plan-agent-fees', parent: this.props.isNew ? NewBreadCrumbTitle : EditBreadCrumbTitle, text: 'Agent Fees' });
                    break;
                }
                case 'general': {
                    feeType = 'Sale';
                    this.props.addBreadcrumb({ key: 'royalty-plan-info', parent: this.props.isNew ? NewBreadCrumbTitle : EditBreadCrumbTitle, text: 'Royalty Plan Info' });
                    break;
                }
                default: {
                    break;
                }
            }

            if (feeType) {
                this.props.onRoyaltyPlanFeeTemplateList({ royaltyPlanTemplateId: this.props.royaltyPlanTemplate.id, feeType: feeType });
            }
        }

        this.setState({ selectedTab: tabKey });
    };

    render() {
        let disabled = (this.props.royaltyPlanTemplate === null || this.props.royaltyPlanTemplate === undefined) && { disabled: true };
        const title = (this.props.royaltyPlanTemplate) ? `Edit Royalty Plan (${this.props.royaltyPlanTemplate.name})` : 'New Royalty Plan';

        const noteTab = (!this.props.isNew && this.state.selectedTab === 'notes') && <NoteTab compType={constants.COMP_TYPE_ROYALTYPLAN} parentTab={this.props.isNew ? NewBreadCrumbTitle : EditBreadCrumbTitle} />;
        const otherFeeTab = (!this.props.isNew && this.state.selectedTab === 'otherFees') && <RoyaltyPlanTemplateOtherFeeTab />;
        const agentFeeTab = (!this.props.isNew && this.state.selectedTab === 'agentFees') && <RoyaltyPlanTemplateAgentFeeTab />;

        return (
            <Suspense fallback={<Spinner text="Loading..." />}>
                <SideMenu activeKey="settings" />
                <div className="content-body">
                    <div style={{ paddingRight: '15px' }}>
                        <PageHeader title={title} />
                        <Panel>
                            <Panel.Body>
                                <Tabs bsStyle="pills"
                                    defaultActiveKey="general" id="royaltyPlanTemplate"
                                    animation={true}
                                    onSelect={this.tabSelectedHandler}>
                                    <Tab eventKey="general" title="Royalty Plan Info">
                                        <RoyaltyPlanTemplateForm
                                            submitted={() => this.submittedHandler()}
                                            cancelled={() => this.cancelledHandler()} />
                                    </Tab>
                                    <Tab eventKey="agentFees" title="Agent Fees" {...disabled}>
                                        {agentFeeTab}
                                    </Tab>
                                    <Tab eventKey="otherFees" title="Other Recurring Fees" {...disabled}>
                                        {otherFeeTab}
                                    </Tab>
                                    <Tab eventKey="notes" title="Notes" {...disabled}>
                                        {noteTab}
                                    </Tab>
                                </Tabs>
                            </Panel.Body>
                        </Panel>
                    </div>
                </div>
            </Suspense>
        );
    }
};

const mapStateToProps = (state) => ({
    royaltyPlanTemplate: state.royaltyPlanTemplate.royaltyPlanTemplate,
    isNew: state.royaltyPlanTemplate.isNew,
    error: state.error
});

const mapDispatchToProps = (dispatch) => ({
    addBreadcrumb: (crumb) => dispatch(breadcrumbAddRoute(crumb)),
    removeBreadcrumb: (crumb) => dispatch(breadcrumbRemoveRoute(crumb)),
    onRoyaltyPlanTemplateSelect: (options) => dispatch(royaltyPlanTemplateSelect(options)),
    onRoyaltyPlanFeeTemplateList: (options) => dispatch(royaltyPlanFeeTemplateList(options)),
    onAlertAdd: (alert) => dispatch(alertAdd(alert))
});

export default withLayout(withAuthentication(connect(mapStateToProps, mapDispatchToProps)(RoyaltyPlanTemplate)));